module.exports = __webpack_public_path__ + "img/video-thumb-5-fr.ead4ccae.png";